import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { setDomainCallCountLoading, setDomainCallCount } from "../../../state/callCenter/domainCallCountSlice";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";

dayjs.extend(utc);

export function* fetchDomainCallCountSaga(action) {
    const countType = action.payload;

    try {
        yield put(setDomainCallCountLoading({ countType }));
        const { domain } = yield select(selectUserCredentials);

        const getDateRange = () => {
            switch (countType) {
                case 'daily':
                    return {
                        start_date: dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
                        end_date: dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
                    };
                case 'currentMonth':
                    return {
                        start_date: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                        end_date: dayjs().utc().format("YYYY-MM-DD HH:mm:ss"),
                    };
                case 'previousMonth':
                    return {
                        start_date: dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                        end_date: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                    };
                default:
                    throw new Error(`Unknown countType: ${countType}`);
            }
        };

        const apiUrl = '?object=cdr2&action=count&format=json';
        const params = {
            ...getDateRange(),
            range_interval: '4 HOUR',
            type: 'Off-net',
            domain: domain,
        };

        const response = yield call(cirrusClient.get, apiUrl, { params });
        yield put(setDomainCallCount({
            countType,
            data: response.data
        }));



    } catch (error) {
        console.error(`Error fetching ${countType} call count:`, error);

    }

}